import {
  Box,
  FormControl,
  IconButton,
} from "@chakra-ui/react";
import { CollecticonArrowSemiSpinCcw } from "@devseed-ui/collecticons-chakra";
import { DEFAULT_BRIGHTNESS, DEFAULT_CONTRAST } from "../settings";
import Slider from "./Slider";



type Props = {
  brightness: number;
  setBrightness: (value: number) => void;
  contrast: number;
  setContrast: (value: number) => void;
};

function ImageControls({
  brightness,
  setBrightness,
  contrast,
  setContrast,
}: Props) {
  return (
    <Box display="flex" flexDir="column" gap="6">
      <FormControl>
        <Box
          fontWeight="semibold"
          fontSize="sm"
          id="brightness"
          display="flex"
          alignItems="center"
          gap="2"
        >
          Brightness
          <IconButton
            aria-label="reset brightness"
            variant="ghost"
            colorScheme="gray"
            size="xs"
            icon={<CollecticonArrowSemiSpinCcw width="10px" height="10px" />}
            isDisabled={brightness === DEFAULT_BRIGHTNESS}
            title="Reset brightness values to default"
            onClick={() => setBrightness(DEFAULT_BRIGHTNESS)}
          />
        </Box>
        <Slider
          labelId="brightness"
          step={0.25}
          minValue={DEFAULT_BRIGHTNESS}
          maxValue={10}
          value={brightness}
          onChange={(value: number) => setBrightness(value)}
          minLabel="Darker"
          maxLabel="Brighter"
        />
      </FormControl>
      <FormControl>
        <Box
          fontWeight="semibold"
          fontSize="sm"
          id="contrast"
          display="flex"
          alignItems="center"
          gap="2"
        >
          Contrast
          <IconButton
            aria-label="reset contrast"
            variant="ghost"
            colorScheme="gray"
            size="xs"
            icon={<CollecticonArrowSemiSpinCcw width="10px" height="10px" />}
            isDisabled={contrast === DEFAULT_CONTRAST}
            title="Reset contrast values to default"
            onClick={() => setContrast(DEFAULT_CONTRAST)}
          />
        </Box>
        <Slider
          labelId="contrast"
          step={0.25}
          minValue={-10}
          maxValue={10}
          value={contrast}
          onChange={(value: number) => setContrast(value)}
          minLabel="Less"
          maxLabel="More"
        />
      </FormControl>
    </Box>
  );
}
export default ImageControls;
